module.exports = __webpack_public_path__ + "img/conference2021.62666966.png";